import { Component, type JSX, Show } from 'solid-js';
import { COLOR_SWATCH_WRAPPER_SIZE_PX } from '../heatmap-stop-layout';
import {
  COLOR_SWATCH_BORDER_RADIUS_CSS,
  COLOR_SWATCH_PADDING_CSS,
  COLOR_SWATCH_SIZE_CSS,
  COLOR_SWATCH_WRAPPER_BORDER_RADIUS_CSS,
} from '../color-swatch-tokens';
import {
  isLightSwatchColor,
  SWATCH_BORDER_CLASS,
} from '../color-swatch-border';

interface ColorSwatchProps {
  color: string;
  onClick?(e: MouseEvent): void;
  testId: string;
}

export const ColorSwatch: Component<ColorSwatchProps> = (props) => {
  const borderClass = (): string =>
    isLightSwatchColor(props.color) ? SWATCH_BORDER_CLASS : '';

  const swatchStyle = (): JSX.CSSProperties => ({
    width: COLOR_SWATCH_SIZE_CSS,
    height: COLOR_SWATCH_SIZE_CSS,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'background-color': props.color,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'border-radius': COLOR_SWATCH_BORDER_RADIUS_CSS,
  });

  return (
    <div
      class="shrink-0 box-border"
      style={{
        width: `${String(COLOR_SWATCH_WRAPPER_SIZE_PX)}px`,
        height: `${String(COLOR_SWATCH_WRAPPER_SIZE_PX)}px`,
        padding: COLOR_SWATCH_PADDING_CSS,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'border-radius': COLOR_SWATCH_WRAPPER_BORDER_RADIUS_CSS,
      }}
    >
      <Show
        when={props.onClick}
        fallback={
          // Read-only swatch: a plain box so it does not look clickable.
          <div
            class={`shrink-0 box-border ${borderClass()} cursor-default`}
            style={swatchStyle()}
            data-testid={props.testId}
          />
        }
      >
        <button
          class={`shrink-0 box-border ${borderClass()} cursor-pointer`}
          style={swatchStyle()}
          onClick={(e) => props.onClick?.(e)}
          type="button"
          data-testid={props.testId}
        />
      </Show>
    </div>
  );
};
